import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt/api/vs/manager';

const list = (merchantId, branchId, conditions) => {
	return Client.get(`${baseUrl}/${merchantId}/tableTags`, {
		branchId,
		...conditions,
	});
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/tableTags`, payload);
};

const update = (merchantId, id, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/tableTags/${id}`, payload);
};

const remove = (merchantId, id, branchId, operateBy) => {
	return Client.del(`${baseUrl}/${merchantId}/tableTags/${id}`, {
		branchId,
		operateBy,
	});
};

export default {
	list,
	create,
	update,
	remove,
};
